import { render, staticRenderFns } from "./KaipiaoOrder.vue?vue&type=template&id=2a57b540&scoped=true&"
import script from "./KaipiaoOrder.vue?vue&type=script&lang=js&"
export * from "./KaipiaoOrder.vue?vue&type=script&lang=js&"
import style0 from "./KaipiaoOrder.vue?vue&type=style&index=0&id=2a57b540&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57b540",
  null
  
)

export default component.exports